export default __webpack_public_path__ + "static/media/megaphone2.685de78d.svg";